module.exports = __webpack_public_path__ + "img/stock-photo.a0a2f554.jpg";